//React
import React from 'react';

// Tanstack Query
import { QueryClient } from '@tanstack/react-query';

//Pages
import { UploadManagement } from 'pages/uploads';

//Store
import { useUserUploadManagementData } from './useUserUploadManagementData';

interface UserUploadManagementProps {
  queryClient: QueryClient;
}

export const UserUploadManagement: React.FC<UserUploadManagementProps> = ({
  queryClient,
}) => {
  const {
    items,
    total,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    pagination,
    setPagination,
    statusGroupCounts,
  } = useUserUploadManagementData(queryClient);

  return (
    <UploadManagement
      items={items}
      total={total}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
      pagination={pagination}
      setPagination={setPagination}
      statusGroupCounts={statusGroupCounts}
    />
  );
};
